export default {
  dialogInfo: {
    isShow: false,
    innerComponent: null,
    dialogProps: null
  }
};



// WEBPACK FOOTER //
// ./src/stores/dialog/_state.js